import { Route } from '@angular/router';
import { UserService } from '../api/services/user.service';
import { UploadImageService } from '../api/services/upload-image.service';
import { VehicleTypesService } from '../api/services/vehicle-types.service';
import { DriverService } from '../api/services/driver.service';
import { DriverListComponent } from './components/driver-list/driver-list.component';
import { VehicleService } from '../api/services/vehicle.service';
import { LicenseCategoryService } from '../api/services/license-category.service';

export default [
  {
    path: '',
    title: 'Te Llevo-Dashboard',
    component: DriverListComponent,
    providers: [
      DriverService,
      VehicleService,
      LicenseCategoryService,
      VehicleTypesService,
      UserService,
      UploadImageService,
    ]
  },
] as Route[];